import { SerializedStyles } from "@emotion/react";
import { Ref, memo, useCallback } from "react";
import { usePartialSubmit } from "src/apps/AppFlow/pages/hooks";
import { FormFlowPage } from "src/components";
import DropdownSelector from "src/components/DropdownSelector";

import { enums, formatters } from "@fraction/shared";

const { BANKRUPTCY_STATUS_MAP } = formatters.enums;

export interface BankruptcyStatusProps {
  onChange: (value: enums.BankruptcyStatus) => void;
  value?: enums.BankruptcyStatus;
  title?: string;

  focusRef?: Ref<HTMLInputElement>;
  onNext: () => void;
  onBack: () => void;
  style?: SerializedStyles;
}

const BankruptcyStatus = ({
  onNext,
  onBack,
  style,
  focusRef,
  value,
  onChange,
  title,
  ...props
}: BankruptcyStatusProps) => {
  const validate = useCallback(() => !!value, [value]);
  const { handleNext, nextDisabled, nextLoading } = usePartialSubmit({ onNext, validate });

  return (
    <FormFlowPage
      {...props}
      title={title || "Have you declared bankruptcy in the past?"}
      description="If you've declared bankruptcy within the past 7 years, that may affect whether Fraction can serve you."
      onNext={handleNext}
      onBack={onBack}
      style={style}
      nextDisabled={nextDisabled}
      nextLoading={nextLoading}
    >
      <DropdownSelector
        label="Bankruptcy status"
        placeholder="Bankruptcy declared?"
        focusRef={focusRef}
        value={value}
        onChange={onChange}
        options={Object.values(enums.BankruptcyStatus).map((type) => ({
          value: type,
          label: BANKRUPTCY_STATUS_MAP[type],
        }))}
      />
    </FormFlowPage>
  );
};

export default memo(BankruptcyStatus);
